import { Trans } from '@lingui/react/macro';

import Badge from '@/design_system/Badge';
import IconPerson from '@/icons/User.svg';
import { ArticleDefectWithRelations } from '@/models/request';
import { useWorkshop } from '@/models/workshop';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import useViewPort from '@/utils/useViewport';

export const DefectAddedByBadge = ({
  defect,
  previousDefect,
}: {
  defect?: ArticleDefectWithRelations;
  previousDefect?: ArticleDefectWithRelations;
}) => {
  const { isMobile } = useViewPort();
  const { request } = useRequestContext();
  const { article, iam } = useArticleContext();

  const defectOrPreviousDefect = defect ?? previousDefect!;

  const addedByCurrentWorkshop = article.workshop?.id === defectOrPreviousDefect.addedByWorkshopId;

  const { data: workshop } = useWorkshop(defectOrPreviousDefect.addedByWorkshopId, {
    enabled: !addedByCurrentWorkshop && !iam.hasOnlyWorkshopScopeOnArticle,
  });

  const workshopName = addedByCurrentWorkshop ? article.workshop?.name : workshop?.name;
  const organizationName = request.organization.name;

  if (!defectOrPreviousDefect.addedByOrganizationId && !defectOrPreviousDefect.addedByWorkshopId) {
    return null;
  }

  return (
    <Badge
      color={isMobile ? 'neutral' : 'secondary'}
      size="large"
      hasBorder
      borderRadius="soft"
      style={{ alignSelf: 'flex-start' }}
    >
      {isMobile && <IconPerson />}
      {defectOrPreviousDefect.addedByOrganizationId && (
        <Trans id="defect-card.description.added-by-organization-name">
          Added by {organizationName}
        </Trans>
      )}
      {defectOrPreviousDefect.addedByWorkshopId &&
        (workshopName ? (
          <Trans id="defect-card.description.added-by-workshop-name">Added by {workshopName}</Trans>
        ) : (
          <Trans id="defect-card.description.added-by-workshop">Added by the workshop</Trans>
        ))}
    </Badge>
  );
};
